
<h1 mat-dialog-title> {{ data.title }}</h1>
<div mat-dialog-content>
      <h2>etes vous sur!!!</h2>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="onNoClick()">No</button>
    <button id="add" mat-button [mat-dialog-close]="data" cdkFocusInitial>yes</button>
</div>
